import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  HourglassEmpty as PendingIcon,
} from '@mui/icons-material';
import type { WebhookEvent } from '../../api/admin';

export function WebhookStatusChip({ status }: { status: WebhookEvent['status'] }) {
  switch (status) {
    case 'processed':
      return <Chip label="Processed" color="success" size="small" icon={<CheckCircleIcon />} />;
    case 'failed':
      return <Chip label="Failed" color="error" size="small" icon={<ErrorIcon />} />;
    case 'pending':
    default:
      return <Chip label="Pending" color="default" size="small" icon={<PendingIcon />} />;
  }
}
